import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Droplets, Target, Shield } from 'lucide-react';
export function SolutionSection() {
  const maps = [{
    icon: Droplets,
    title: 'MAPA 1 — SANGRADO',
    desc: "Encuentras el dinero que se te va sin darte cuenta: fugas, cargos repetidos, 'gastos fantasma'. No para que te castigues. Para que recuperes control.",
    color: 'bg-red-50 text-red-800 border-red-100'
  }, {
    icon: Target,
    title: 'MAPA 2 — ATAQUE',
    desc: 'Ordenas tus deudas con una regla simple y aplicas una fórmula que te dice: qué pagar, cuánto pagar y en qué orden. Sin improvisar cada mes.',
    color: 'bg-emerald-50 text-emerald-800 border-emerald-100'
  }, {
    icon: Shield,
    title: 'MAPA 3 — PROTECCIÓN',
    desc: "Creas un mini fondo anti-imprevistos. Porque si un imprevisto te regresa a la tarjeta, no es 'mala suerte': era una pieza faltante.",
    color: 'bg-amber-50 text-amber-800 border-amber-100'
  }];
  return <Section background="cream" data-id="element-124">
      <div className="text-center mb-16" data-id="element-125">
        <h2 className="text-3xl md:text-4xl text-[#2D3B2D] mb-6" data-id="element-126">
          Lo que hace diferente a este plan: <br data-id="element-127" />
          <span className="text-[#C4A962] italic" data-id="element-128">El Método 3 Mapas</span>
        </h2>
        <p className="text-lg text-[#4A5D4A] max-w-2xl mx-auto" data-id="element-129">
          Este plan está diseñado para la vida real: trabajo, casa, familia,
          cansancio… y cero ganas de "sentarte a presupuestar".
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-130">
        {maps.map((map, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.2
      }} className={`p-8 rounded-2xl border ${map.color} h-full flex flex-col`} data-id="element-131">
            <div className="mb-6 bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm" data-id="element-132">
              <map.icon size={24} data-id="element-133" />
            </div>
            <h3 className="text-xl font-bold mb-4 font-serif" data-id="element-134">{map.title}</h3>
            <p className="leading-relaxed opacity-90" data-id="element-135">{map.desc}</p>
          </motion.div>)}
      </div>

      <div className="mt-16 bg-[#2D3B2D] text-[#FDF8F0] p-8 md:p-12 rounded-3xl text-center relative overflow-hidden" data-id="element-136">
        {/* Decorative circles */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-137" />
        <div className="absolute bottom-0 right-0 w-48 h-48 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-138" />

        <div className="relative z-10 max-w-2xl mx-auto" data-id="element-139">
          <h3 className="text-2xl md:text-3xl font-serif mb-6" data-id="element-140">
            "Pero yo ya sé lo básico…"
          </h3>
          <p className="text-lg opacity-90 mb-8" data-id="element-141">
            Saber no es lo que te falta. Lo que te falta es un plan que se
            sostenga cuando estás cansada, un sistema que reduzca decisiones y
            una forma de avanzar sin colapsar emocionalmente.
          </p>
          <p className="font-medium text-[#C4A962]" data-id="element-142">
            Este plan no compite con tu vida. Se adapta.
          </p>
        </div>
      </div>
    </Section>;
}